import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import StarIcon from '@material-ui/icons/Star';
import { useHomeDailyTip } from '../../hooks/useHomeDailyTip';

interface HomeDailyTipProps {
  embedded?: boolean;
}

export const HomeDailyTip = ({ embedded = false }: HomeDailyTipProps) => {
  const classes = useStyles();
  const tip = useHomeDailyTip();
  if (!tip) return null;

  const copy = tip.summary || tip.detail || '';
  return (
    <Box className={embedded ? classes.embedded : classes.standalone}>
      <Box className={classes.content}>
        <Box className={classes.labelWrap}>
          <StarIcon className={classes.icon} />
          <Typography className={classes.label}>Consejo del día</Typography>
        </Box>
        <Typography className={classes.text}>
          <Box component="span" className={classes.title}>
            {tip.title}
          </Box>
          {copy ? `: ${copy}` : ''}
        </Typography>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  standalone: {
    marginBottom: theme.spacing(3),
    borderRadius: 8,
    border: `1px solid ${theme.palette.border}`,
    borderLeft: `4px solid ${theme.palette.secondary.main}`,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(1, 1.5),
  },
  embedded: {
    borderTop: `1px solid ${theme.palette.border}`,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(1, 1.5),
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    minHeight: 20,
    '@media (max-width: 700px)': {
      alignItems: 'flex-start',
      flexDirection: 'column',
      gap: theme.spacing(0.5),
    },
  },
  labelWrap: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    flexShrink: 0,
    fontSize: '1.1rem',
  },
  icon: { color: theme.palette.secondary.main, fontSize: 17 },
  label: {
    color: theme.palette.secondary.dark,
    fontWeight: 700,
    fontSize: '0.9rem',
    whiteSpace: 'nowrap',
  },
  text: {
    flex: 1,
    minWidth: 0,
    color: theme.palette.text.secondary,
    fontSize: '0.9rem',
    lineHeight: 1.45,
    overflowWrap: 'anywhere',
  },
  title: { color: theme.palette.text.primary, fontWeight: 700 },
}));
